import createVueComponent from '../createVueComponent';

const Map = createVueComponent('MapIcon', [
  [
    'polygon',
    { points: '3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21', key: 'ok2ie8' },
  ],
  ['line', { x1: '9', x2: '9', y1: '3', y2: '18', key: 'w34qz5' }],
  ['line', { x1: '15', x2: '15', y1: '6', y2: '21', key: 'volv9a' }],
]);

export default Map;
